import { fork, all } from 'redux-saga/effects';
import { watchApiTask } from 'app/sagas';
import { api } from 'app/api';
import * as actions from './managerDashboardActions';

export const getSchoolsByContractTask = watchApiTask(
  actions.GET_SCHOOLS_BY_CONTRACT,
  api.post,
  '/evaluation-system/getSchoolsByContract.php',
);

export const getApplicationsByContractSchoolsTask = watchApiTask(
  actions.GET_APPLICATIONS_BY_CONTRACT_SCHOOLS,
  api.post,
  '/evaluation-system/getApplicationsByContractSchools.php',
);

export const getReturnsAverageInfoTask = watchApiTask(
  actions.GET_RETURNS_AVERAGE_INFO,
  api.post,
  '/evaluation-system/getReturnsAverageInfo.php',
);

export const getReturnsAverageInfoSpecificTask = watchApiTask(
  actions.GET_RETURNS_AVERAGE_INFO_SPECIFIC,
  api.post,
  '/evaluation-system/getReturnsAverageInfoSpecific.php',
);

export function* sagas() {
  yield all([
    fork(getSchoolsByContractTask),
    fork(getApplicationsByContractSchoolsTask),
    fork(getReturnsAverageInfoTask),
    fork(getReturnsAverageInfoSpecificTask),
  ]);
}
